export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 80,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_amzMarketName') || '市场',
    field: 'marketName',
    minWidth: 100,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_regionName') || '所属地区',
    field: 'regionName',
    minWidth: 120,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_categoryFullName') || '产品分类',
    field: 'categoryFullName',
    minWidth: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_exchangeCurrencyUnit') || '货币单位',
    field: 'v_currency',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.Status') || '有效状态',
    field: 'amzControlParamsStatus',
    minWidth: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_commissionRate') || '佣金比例',
    field: 'commissionRate',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => `${cellValue || 0}%`,
  },
  {
    title: that.$l('table_label_advertisingRate') || '广告比例',
    field: 'advertisingRate',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => `${cellValue || 0}%`,
  },
  {
    title: that.$l('table_label_storageUnitPrice') || '仓储单价',
    field: 'storageUnitPrice',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_inStorageMonth') || '在库时长',
    field: 'inStorageMonth',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_salesReturnRate') || '退货率',
    field: 'salesReturnRate',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => `${cellValue || 0}%`,
  },
  {
    title: that.$l('table_label_shipUnitPrice') || '头程单价',
    field: 'shipUnitPrice',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_tariffsRate') || '关税税率',
    field: 'tariffsRate',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => `${cellValue || 0}%`,
  },
  {
    title: that.$l('table_label_salesTax') || '消费税',
    field: 'salesTax',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => `${cellValue || 0}%`,
  },
  {
    title: that.$l('table_label_localTax') || '地方税',
    field: 'localTax',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => `${cellValue || 0}%`,
  },
  {
    title: that.$l('table_label_vatRate') || '增值税率',
    field: 'vatRate',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => `${cellValue || 0}%`,
  },
  {
    title: that.$l('table_label_refundTaxRate') || '退税率',
    field: 'refundTaxRate',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => `${cellValue || 0}%`,
  },
  {
    title: that.$l('table_label_chinaVatRate') || '中国增值税率',
    field: 'chinaVatRate',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => `${cellValue || 0}%`,
  },
  {
    title: that.$l('table_label_truckingFee') || '货代卡车费',
    field: 'truckingFee',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_freightFee') || '货代头程运费',
    field: 'freightFee',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('INDEX.creator') || '创建人',
    field: 'createByName',
    minWidth: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    minWidth: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
